import { Component, OnInit } from '@angular/core';
import { Store } from '@app/_classes/store.class';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {
  storeName = '';

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.storeName = this.store?.store_name || '';
  }
}
